<template>
    <BreadCrumb PageTitle="Liste des matières" />
    <ListeMatiere />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeMatiere from "../../components/Matiere/ListeMatiere.vue";

  
    export default defineComponent({
      name: "ListeMatierePage",
      components: {
        BreadCrumb,
        ListeMatiere,
      },
    });
  </script>